import classes from "./Services.module.scss";
import useAPI from "../../../hooks/useAPI";
import { useQuery } from "react-query";

const Services = () => {
    const api = useAPI();

    const { data: benefits, isLoading: isFetching } = useQuery(["productItems.Benefits"], () => api.list(`/banners/product_benefits`));

    return (
        <ul className={classes.wrapper}>
            {benefits?.items.map((item) => (
                <li key={item.id}>
                    <span>
                        <img src={item.image} alt="{item.name}" />
                    </span>
                    <div>{item.button}</div>
                </li>
            ))}
        </ul>
    );
};

export default Services;
